module.exports = __webpack_public_path__ + "img/button2.2d884633.png";